<style lang="less" scoped>
  @import url('../../../style/common/variable.less');
  .meetingtype{width: 100%;
    ul{margin: 0;padding: 0;display: flex;flex-wrap: wrap;
      li{width: 266px;list-style-type: none;margin-bottom: 15px;margin: 0 16px; margin-bottom: 15px;cursor: pointer;
        .image{width: 100%;height: 150px;}
        span{line-height: 24px;font-size: 16px;text-align: left;display: block;letter-spacing: 1px;color: #666666;height: 48px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
        p{margin: 0;text-align: left;background: #fff3cd;padding: 5px;font-size: 14px;letter-spacing: 1px;}}
      li:hover{span{color:#1e6bbe;}}}
    /deep/.el-tabs__item,.is-top{font-size: 18px;font-weight: 600;}
  }
@media screen and (max-width: @max-screen)
{
  .meetingtype{
    ul{display: flex;flex-wrap: wrap;flex-direction: column;margin: 0;padding: 0;}
      li{width: 95vw !important;height: 353px;margin: 0 !important;
        .image{width: 100%;height: 238px !important;}
      }
  }
}
</style>

<template>
  <div class="meetingtype">
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="(item, index) in TabsList" :key="index" :label="item.title" :name="item.title">
        <ul class="content">
          <li v-for="(each, index) in item.content" :key="index" @click="handleClick(each)">
            <div class="image">
              <img :src="each.thumb" alt="" style="width:100%;height:100%">
            </div>
            <span>{{each.title}}</span>
            <p>
              <b style="color: #856404;">{{each.addtime * 1000 | formatYMDHM() }}</b>
            </p>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
    <el-button type="primary" style="width:106px;margin-top: 20px;" @click="tabClick(TabsList[0].cli)">查看更多</el-button>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  mixins: [filters],
  props:
  {
    TabsList: {type: Array},
    activeName: {type: String}
  },
  data()
  {
    return {
    }
  },
  methods:
  {
    //查看详情页
    handleClick(each)
    {
      this.$emit('handleClick', each)
    },
    //点击tab页
    tabClick(click)
    {
      this.$emit('tabClick', this.activeName, click)
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/plugins/app/assembly/MeetingList.vue